export const HASILTESTPSIKOLOGISMID_GET = 'HASILTESTPSIKOLOGISMID_GET';
export const HASILTESTPSIKOLOGISSEM_GET = 'HASILTESTPSIKOLOGISSEM_GET';